/*https://medium.com/@ryanchenkie_40935/angular-authentication-using-route-guards-bf7a4ca13ae3*/
//https://stackoverflow.com/a/50143721/6241324
import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { AccessService } from '../services/access.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root', // Ensures it's a singleton
})
export class AuthGuardService implements CanActivate {
  constructor(private auth: AccessService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    var pathSegments = _.compact(state.url.split('/'));
    var api_key =
      pathSegments.length >= 2 &&
      pathSegments[0] == 'fauxbox' &&
      pathSegments[1].length == 32
        ? pathSegments[1]
        : pathSegments.length >= 3 &&
          pathSegments[0] == 'fauxbox' &&
          pathSegments[2].length == 32
        ? pathSegments[2]
        : null; // for mailer
    return this.auth.checkUserAccess(api_key).pipe(
      map((response) => {
        if (response.status === 0) {
          this.auth.me = response;
          //alert('Not Logged In:' +response.msg);
          localStorage.setItem('loginUrl', state.url);
          this.router.navigate(['/authentication/sign-in']);
          return false;
        } else {
          return true;
        }
      }),
      catchError((err) => {
        localStorage.setItem('loginUrl', state.url);
        this.router.navigate(['/authentication/sign-in']);
        return of(false);
      }),
    );
  }
}
